import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";
import CpWorldWideTable from "../Table/CpfWorldWideTable";
import Navbar from "../Navbar";
import { Link } from "react-router-dom";

const CpWorldWide = () => {
  const handleLogout = (event) => {
    event.preventDefault();
    sessionStorage.clear("token");
    window.location = "/login";
  };

  return (
    <div>
      <div className="navbar">
        <a href="/home">
          <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
        </a>
        <button className="logout-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>
      <div className="global-market-container">
        <div className="global-market-grid">
          <Link
            className="global-market-menuitem"
            to="/global-market/global-feed-production"
          >
            Global feed production
          </Link>
          <Link
            className="global-market-menuitem"
            to="/global-market/cp-world-wide"
          >
            CP World wide
          </Link>
          <Link
            className="global-market-menuitem"
            to="/global-market/cpf-feed-production"
          >
            CPF feed production
          </Link>
        </div>
        <div className="geomap-powerbi">
          <iframe
            title="Production"
            width="100%"
            height="541.25"
            src="https://app.powerbi.com/reportEmbed?reportId=2408d338-8800-4ffe-9f14-136e4ee1aad4&autoAuth=true&ctid=8c308e15-1480-4168-aed7-b0f7a1352095"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
        <div className="cpf-world-wide-title">
          ธุรกิจอาหารสัตว์เครือซีพี 17 ประเทศ ปี 2022
        </div>
        <CpWorldWideTable />
        {/* <table className="cpf-world-wide-table">
          <tr>
            <td style={{ backgroundColor: "#003600" }}></td>
            <td style={{ backgroundColor: "#003600", color: "#b6d241" }}>
              รวม
            </td>
            <td style={{ backgroundColor: "#003600", color: "#b6d241" }}>
              45,949
            </td>
            <td style={{ backgroundColor: "#003600", color: "#b6d241" }}>
              34,285
            </td>
            <td style={{ backgroundColor: "#003600", color: "#b6d241" }}>
              75%
            </td>
            <td style={{ backgroundColor: "#112b43", color: "white" }}>
              19,835
            </td>
            <td style={{ backgroundColor: "#112b43", color: "white" }}>58%</td>
            <td style={{ backgroundColor: "#112b43", color: "white" }}>
              14,450
            </td>
            <td style={{ backgroundColor: "#112b43", color: "white" }}>42%</td>
          </tr>
        </table> */}
      </div>
    </div>
  );
};

export default CpWorldWide;
